import React from "react";
import { Button } from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";

interface AddPaymentMethodButtonProps {
  onClick?: () => void;
  text: string;
  disabled?: boolean;
  isSelected?: boolean;
}

const AddPaymentMethodButton = ({ onClick, text, disabled = false, isSelected = false }: AddPaymentMethodButtonProps) => {
  return (
    <Button
      variant="outline-light"
      onClick={onClick}
      disabled={disabled}
      style={{
        width: "100%",
        marginTop: "16px",
        padding: "10px",
        fontSize: "14px",
        fontWeight: "500",
        borderRadius: "8px",
        border: isSelected ? "2px solid #ffc107" : "2px dashed rgba(255, 255, 255, 0.3)",
        backgroundColor: isSelected ? "rgba(255, 193, 7, 0.1)" : "rgba(255, 255, 255, 0.02)",
        color: isSelected ? "#ffc107" : "rgba(255, 255, 255, 0.7)",
        transition: "all 0.2s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        opacity: disabled ? 0.5 : 1
      }}
      onMouseEnter={(e) => {
        if (!disabled && !isSelected) {
          e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.5)";
          e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
          e.currentTarget.style.color = "rgba(255, 255, 255, 0.9)";
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled && !isSelected) {
          e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.3)";
          e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.02)";
          e.currentTarget.style.color = "rgba(255, 255, 255, 0.7)";
        }
      }}
    >
      <Plus size={16} />
      {text}
    </Button>
  );
};

export default AddPaymentMethodButton; 